module.exports = __webpack_public_path__ + "static/media/twitter.6353833a.webp";